export const DEFAULT_ALERT_SCORES = [
  {
    id: '0,1,6',
    name: 'AML-TM Detection'
  },
  {
    id: '4,13',
    name: 'Transaction Screening'
  },
  {
    id: '2,3',
    name: 'Name Screening'
  },
  {
    id: '5,10,11,12,14',
    name: 'Customer Risk Scoring'
  },
  {
    id: '21',
    name: 'Fraud Detection'
  },
  {
    id: '25,29',
    name: 'Fraud Prevention'
  }
];

export const PROD_IDS = {
  AML_TM: {
    ID: '0,1,6',
    NAME: 'AML-TM'
  },
  TS: {
    ID: '4,13',
    NAME: 'Transaction Monitoring'
  },
  NS: {
    ID: '2,3',
    NAME: 'Name Screening'
  },
  CRS: {
    ID: '5,10,11,12,14',
    NAME: 'Customer Risk Screening'
  },
  FRAUD: {
    ID: '21',
    NAME: 'Fraud Survelliance'
  },
  FRAUD_PREV: {
    ID: '25',
    NAME: 'Fraud Prevention'
  },
  FRAUD_PREV_BATCH: {
    ID: '29',
    NAME: 'Fraud Prevention'
  },
  RT_FRAUD: {
    ID: '24',
    NAME: 'Fraud Prevention'
  }
};
